"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var restful_model_1 = __importDefault(require("./restful-model"));
var attributes_1 = __importDefault(require("./attributes"));
var event_participant_1 = __importDefault(require("./event-participant"));
var event_conferencing_1 = __importDefault(require("./event-conferencing"));
var when_1 = __importDefault(require("./when"));
var event_notification_1 = __importDefault(require("./event-notification"));
var ICSMethod;
(function (ICSMethod) {
    ICSMethod["Request"] = "request";
    ICSMethod["Publish"] = "publish";
    ICSMethod["Reply"] = "reply";
    ICSMethod["Add"] = "add";
    ICSMethod["Cancel"] = "cancel";
    ICSMethod["Refresh"] = "refresh";
})(ICSMethod = exports.ICSMethod || (exports.ICSMethod = {}));
var Event = /** @class */ (function (_super) {
    __extends(Event, _super);
    function Event(connection, props) {
        var _this = _super.call(this, connection, props) || this;
        _this.calendarId = '';
        _this.when = new when_1.default();
        _this.initAttributes(props);
        return _this;
    }
    Object.defineProperty(Event.prototype, "start", {
        get: function () {
            var _a, _b, _c, _d;
            return (((_a = this.when) === null || _a === void 0 ? void 0 : _a.startTime) || ((_b = this.when) === null || _b === void 0 ? void 0 : _b.startDate) || ((_c = this.when) === null || _c === void 0 ? void 0 : _c.time) || ((_d = this.when) === null || _d === void 0 ? void 0 : _d.date));
        },
        set: function (val) {
            if (!this.when) {
                this.when = new when_1.default();
            }
            if (typeof val === 'number') {
                if (val === this.when.endTime) {
                    this.when.time = val;
                    this.when.endTime = undefined;
                }
                else {
                    this.when.time = undefined;
                    this.when.startDate = undefined;
                    this.when.date = undefined;
                    this.when.startTime = val;
                }
            }
            if (typeof val === 'string') {
                if (val === this.when.endDate) {
                    this.when.date = val;
                    this.when.endDate = undefined;
                }
                else {
                    this.when.time = undefined;
                    this.when.startTime = undefined;
                    this.when.date = undefined;
                    this.when.startDate = val;
                }
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Event.prototype, "end", {
        get: function () {
            var _a, _b, _c, _d;
            return (((_a = this.when) === null || _a === void 0 ? void 0 : _a.endTime) || ((_b = this.when) === null || _b === void 0 ? void 0 : _b.endDate) || ((_c = this.when) === null || _c === void 0 ? void 0 : _c.time) || ((_d = this.when) === null || _d === void 0 ? void 0 : _d.date));
        },
        set: function (val) {
            if (!this.when) {
                this.when = new when_1.default();
            }
            if (typeof val === 'number') {
                if (val === this.when.startTime) {
                    this.when.time = val;
                    this.when.startTime = undefined;
                }
                else {
                    this.when.time = undefined;
                    this.when.endDate = undefined;
                    this.when.date = undefined;
                    this.when.endTime = val;
                }
            }
            if (typeof val === 'string') {
                if (val === this.when.startDate) {
                    this.when.date = val;
                    this.when.startDate = undefined;
                }
                else {
                    this.when.time = undefined;
                    this.when.endTime = undefined;
                    this.when.date = undefined;
                    this.when.endDate = val;
                }
            }
        },
        enumerable: true,
        configurable: true
    });
    Event.prototype.deleteRequestQueryString = function (params) {
        if (params === void 0) { params = {}; }
        var qs = {};
        if (params.hasOwnProperty('notify_participants')) {
            qs.notify_participants = params.notify_participants;
        }
        return qs;
    };
    Event.prototype.save = function (params, callback) {
        if (params === void 0) { params = {}; }
        if (this.conferencing &&
            this.conferencing.details &&
            this.conferencing.autocreate) {
            return Promise.reject(new Error("Cannot set both 'details' and 'autocreate' in conferencing object."));
        }
        return _super.prototype.save.call(this, params, callback);
    };
    Event.prototype.saveRequestBody = function () {
        var json = _super.prototype.saveRequestBody.call(this);
        if (!this.notifications) {
            delete json.notifications;
        }
        return json;
    };
    Event.prototype.rsvp = function (status, comment, callback) {
        var _this = this;
        return this.connection
            .request({
            method: 'POST',
            body: { event_id: this.id, status: status, comment: comment },
            path: '/send-rsvp',
        })
            .then(function (json) {
            _this.fromJSON(json);
            if (callback) {
                callback(null, _this);
            }
            return Promise.resolve(_this);
        })
            .catch(function (err) {
            if (callback) {
                callback(err);
            }
            return Promise.reject(err);
        });
    };
    Event.prototype.generateICS = function (options) {
        if (this.calendarId == '' || !this.when.isSet()) {
            throw new Error('Cannot generate an ICS file for an event without a Calendar ID or when set');
        }
        var optionsPayload = {};
        if (options) {
            optionsPayload = {
                ical_uid: options.iCalUID,
                prodid: options.prodId,
                method: options.method,
            };
        }
        return this.connection
            .request({
            method: 'POST',
            body: __assign(__assign({}, this.saveRequestBody()), { ics_options: optionsPayload }),
            path: '/events/to-ics',
        })
            .then(function (response) {
            if (!response.ics) {
                throw new Error("Unexpected response from the API server. Returned 200 but no 'ics' string found.");
            }
            return response.ics;
        });
    };
    Event.collectionName = 'events';
    Event.attributes = __assign(__assign({}, restful_model_1.default.attributes), { calendarId: attributes_1.default.String({
            modelKey: 'calendarId',
            jsonKey: 'calendar_id',
        }), iCalUID: attributes_1.default.String({
            modelKey: 'iCalUID',
            jsonKey: 'ical_uid',
            readOnly: true,
        }), messageId: attributes_1.default.String({
            modelKey: 'messageId',
            jsonKey: 'message_id',
            readOnly: true,
        }), title: attributes_1.default.String({
            modelKey: 'title',
        }), description: attributes_1.default.String({
            modelKey: 'description',
        }), owner: attributes_1.default.String({
            modelKey: 'owner',
            readOnly: true,
        }), participants: attributes_1.default.Collection({
            modelKey: 'participants',
            itemClass: event_participant_1.default,
        }), readOnly: attributes_1.default.Boolean({
            modelKey: 'readOnly',
            jsonKey: 'read_only',
        }), location: attributes_1.default.String({
            modelKey: 'location',
        }), when: attributes_1.default.Object({
            modelKey: 'when',
            itemClass: when_1.default,
        }), busy: attributes_1.default.Boolean({
            modelKey: 'busy',
        }), status: attributes_1.default.String({
            modelKey: 'status',
            readOnly: true,
        }), recurrence: attributes_1.default.Object({
            modelKey: 'recurrence',
        }), masterEventId: attributes_1.default.String({
            modelKey: 'masterEventId',
            jsonKey: 'master_event_id',
            readOnly: true,
        }), originalStartTime: attributes_1.default.DateTime({
            modelKey: 'originalStartTime',
            jsonKey: 'original_start_time',
            readOnly: true,
        }), conferencing: attributes_1.default.Object({
            modelKey: 'conferencing',
            itemClass: event_conferencing_1.default,
        }), notifications: attributes_1.default.Collection({
            modelKey: 'notifications',
            itemClass: event_notification_1.default,
        }), metadata: attributes_1.default.Object({
            modelKey: 'metadata',
        }), jobStatusId: attributes_1.default.String({
            modelKey: 'jobStatusId',
            jsonKey: 'job_status_id',
            readOnly: true,
        }) });
    return Event;
}(restful_model_1.default));
exports.default = Event;
